import axios from './Interceptor.js';
let address = window.global_config.BASE_URL2;

export const GetListBySystem = data => {
  return axios({
    method: 'get',
    url: `${address}QuestionnaireCenter/GetListByQid?qid=${data}`
  });
};

export const BindDiagnosisCondition = (qid, data) => {
  return axios({
    method: 'post',
    url: `${address}QuestionnaireCenter/BindDiagnosisCondition?qid=${qid}`,
    data
  });
};

// showData

export const Diagnosis = (qid, cqid) => {
  return axios({
    method: 'get',
    url: `${address}QuestionnaireCenter/Diagnosis?qid=${qid}&cqid=${cqid}`
  });
};

// 模板下载
export const QuestionnaireTemplates = qid => {
  return axios({
    method: 'get',
    url: `${address}QuestionnaireCenter/QuestionnaireTemplates?qid=${qid}`
  });
};

// 模板上传
export const QuestionnaireUpload = (data) => {
  return axios({
    method: 'post',
    url: `${address}QuestionnaireCenter/QuestionnaireUpload`,
    data
  });
};
